import {
  GetUsageEventsReportConfigurationResponseSchema,
  type GetUsageEventsReportConfigurationResponse,
} from '@vy/api-definition';
import { useQuery, type QueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

async function usageEventsReportConfigurationQuery() {
  const api = getPrivateApi();
  const response = await api.getUsageEventsReportConfiguration();

  return GetUsageEventsReportConfigurationResponseSchema.parse(response);
}

export function useUsageEventsReportConfiguration(
  options?: CustomUseQueryOptions<GetUsageEventsReportConfigurationResponse>,
) {
  return useQuery(
    queryKeys.usageEventsReportConfiguration(),
    usageEventsReportConfigurationQuery,
    { ...options },
  );
}

export async function prefetchUsageEventsReportConfiguration(queryClient: QueryClient) {
  return queryClient.prefetchQuery(
    queryKeys.usageEventsReportConfiguration(),
    usageEventsReportConfigurationQuery,
  );
}
